module.exports = __webpack_public_path__ + "static/media/informatii-icon.b562af16.svg";